/* eslint-disable prefer-template */
/* eslint-disable react/jsx-indent */
/* eslint-disable react/destructuring-assignment */
/* eslint-disable no-unused-vars */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-console */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable import/no-unresolved */
/* eslint-disable prettier/prettier */
/* eslint-disable react/jsx-one-expression-per-line */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable no-empty */
/* eslint-disable no-nested-ternary */
/* eslint no-param-reassign: "error" */
import React, { useEffect, useState } from 'react';

import { postTurbinesOperation } from 'services/turbine-operation';
import {
  IBulletimTurbineOperationDetailsData,
  IInfoTurbinesOperation,
} from 'interfaces/Grid';
import { useFarolStatusContext } from 'context/FarolStatusContext';

import useStyles from './style';

const InfoTurbinesOperation = (turbineData: any) => {
  const {farolStatus, setFarolStatus} = useFarolStatusContext();
  const [turbine, setTurbine] = useState<IInfoTurbinesOperation>();
  const classes = useStyles();
  const [turbineItens, setTurbineItens] = useState<
    IBulletimTurbineOperationDetailsData[]
  >([]);
  const [totais, setTotais] = useState<string>('');
  
  const turbineDataPost = async parametroNovo => {
    try {
      const { data: resp } = await postTurbinesOperation(parametroNovo);
      setTurbineItens(resp);

      let valorQuant = 0;
      let valorNot = 0;
      resp.forEach(el => {
        valorQuant += Number(el.quant);
        valorNot += el.notOp;
      });
      setTotais(valorQuant - valorNot + '/' + valorQuant);
    } catch (error) {
      console.log(error);
    } finally {
      setFarolStatus(false);
    }
  };

  const parametroNovo = React.useMemo<IInfoTurbinesOperation>(() => {
    return {
      installationIds: turbineData.turbineData.installationIds,
      supplierExecutors: turbineData.turbineData.supplierExecutors,
      date: turbineData.turbineData.date,
      areaType: turbineData.turbineData.areaType,
      type: turbineData.turbineData.type,
      order: turbineData.turbineData.order,
    };
  }, [turbineData.turbineData]);

  useEffect(() => {
    turbineDataPost(parametroNovo);
  }, [parametroNovo]);

  useEffect(() => {
    if (farolStatus)
      turbineDataPost(parametroNovo);
  }, [farolStatus]);

  
  return (
    <div className={classes.divMain}>
      <label
        style={{ backgroundColor: 'white' }}
        className="MuiFormLabel-root MuiInputLabel-root MuiInputLabel-formControl MuiInputLabel-animated MuiInputLabel-shrink MuiInputLabel-outlined MuiFormLabel-filled"
        data-shrink="true"
      >
        Total de Turbinas em Operação: &nbsp;
        <span className={classes.spanLabel}>{totais} &nbsp;</span>
      </label>
      <div
        style={{
          justifyContent: 'space-evenly',
          display: 'flex',
          marginTop: '5px',
        }}
      >
        {turbineItens?.map((item: any) => {
          return (
            <div className={classes.turbine}>
              {item.executor === 'GAMESA'
                ? 'SG'
                : item.executor === 'GE Cypress'
                ? 'CYPRESS'
                : item.executor.substring(0, 2)}
              :
              <span className={classes.valueTurbine}>
                {item.quant - item.notOp}/{item.quant}
              </span>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default InfoTurbinesOperation;
